import { colors } from "src/common/colors";
import styled from "styled-components";
import {SVG} from 'src/common/svg';
import useInput from "../hooks/useInput";
import Input from "../components/common/Input";
import {useEffect, useRef, useState} from "react";
import Button from "../components/common/Button";
import useSignin from "../hooks/useSignIn";
import SToast from "src/components/common/SToast";

export default function SignIn() {
  const [id, setId] = useInput('');
  const [password, setPassword] = useInput('');
  const [signinInProgress, setSigninInProgress] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const {goSignin} = useSignin();
  const {customErrorToast} = SToast();

  const onSubmit = async(e:React.FormEvent) => {
    e.preventDefault();
    if(signinInProgress) {
      return;
    } else if(id.length < 1) {
      customErrorToast('아이디를 입력해 주세요')
      return;
    } else if (password.length < 1) {
      customErrorToast('비밀번호를 입력해 주세요')
      return;
    }

    try {
      setSigninInProgress(true);
      const loginCall = await goSignin(id, password);
      if(loginCall !== 200) {
        customErrorToast('아이디와 비밀번호를 다시 확인해 주세요')
      }
    } finally {
      setSigninInProgress(false);
    }
  }

  useEffect(() => {
    if (ref.current) {
      (ref.current.children[0] as HTMLInputElement).focus();
    }
  }, [])

  return (
    <Container>
      <div className="logo">
        <img src={SVG.logo_main} alt="로고" />
      </div>
      <form onSubmit={onSubmit}>
        <h1>로그인</h1>
        <div className="input-wrapper" ref={ref}>
          <Input
            value={id}
            onChange={setId}
            className="default"
            placeholder="관리자 아이디"
            />
        </div>
        <div className="input-wrapper">
          <Input
            type="password"
            value={password}
            onChange={setPassword}
            className="default"
            placeholder="비밀번호"
            />
        </div>
        <div className="button-wrapper">
          <Button
            type="submit"
            text="로그인"
            className="form-submit"
            />
        </div>
      </form>
      <span>관리자 페이지</span>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${colors.darkBlue};
  background-image: url(${SVG.background_main});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  
  &>.logo {
    position: absolute;
    width: 200px;
    height: 90px;
    top: 44px;
    left: 44px;
  }
  
  &>form {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 0 40px;
    width: 507px;
    background-color: #FFF;
    border-radius: 24px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h1 {
      color: ${colors.black};
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      margin-bottom: 19px;
    }
    .input-wrapper {
      position: relative;
      max-width: 372px;
      width: 100%;
      height: 82px;
      margin-bottom: 18px;
      input {
        padding-left: 25px;
        /* width: calc(100% - 25px); */
        width: 100%;
        height: 100%;
      }
    }
    .button-wrapper {
      position: relative;
      max-width: 372px;
      width: 100%;
      height: 73px;
      margin-top: calc(27px - 18px);
    }
  }
  
  &>:last-child {
    position: absolute;
    right: 34px;
    bottom: 26px;
    color: #FFF;
    font-size: 18px;
    font-weight: 700;
  }
`